/* eslint-disable max-params */
import { NUMBER } from "../../constants/app-constants";

/**
 * Params:
 * rt – - periodic interest rate represented as a decimal.
 * tr – - number of total payments / periods.
 * pr – - present value -- borrowed or invested principal.
 * fv – - future value of loan or annuity.
 * type – - when payment is made: beginning of period is 1; end, 0.
 * Returns:
 * double representing periodic payment amount.
 */

/* eslint-disable no-magic-numbers */
const pmtFormula = (pr, rt, tr, fv, type = 0) => {
    const p = Number(pr);
    const r = Number(rt);
    const n = Number(tr);
    if (p === 0 || r === 0 || n === 0) {
        return 0;
    }
    //r /= (12 * 100);
    //n *= 12;
    //return p * r * Math.pow((1 + r), n) / (Math.pow((1 + r), n) - 1);

    return -r * (pr * Math.pow(1 + r, n) + fv) / ((1 + r * type) * (Math.pow(1 + r, n) - 1));
};

export const calculateEmiAUV2 = ({ loanAmount, lenderFee, balloonPercentage, lenderMonthlyFee, interestRate, tenure, periodsInAYear = NUMBER.FIFTY_TWO }) => {
    const periodicInterestRate = interestRate / (NUMBER.HUNDRED * periodsInAYear);
    const presentValue = -1 * (loanAmount + lenderFee);
    const futureValue = (loanAmount * balloonPercentage) / NUMBER.HUNDRED;

    const pmtValue = pmtFormula(presentValue, periodicInterestRate, tenure, futureValue);
    const finalEmi = pmtValue + ((lenderMonthlyFee * 12) / periodsInAYear);

    return Math.ceil(finalEmi);
};

// eslint-disable-next-line max-params
export const calculateEmiAU = (principal, interestRate, tenure, periodsInAYear = NUMBER.FIFTY_TWO) => {
    const periodicInterestRate = interestRate / (NUMBER.HUNDRED * periodsInAYear);
    const emi = (principal * periodicInterestRate) / (1 - Math.pow(1 + periodicInterestRate, -tenure));
    return Math.ceil(emi);
};

// eslint-disable-next-line max-params
export const calculatePrincipalAUV2 = ({
    emiValue,
    interestRate,
    tenure,
    periodsInAYear = NUMBER.FIFTY_TWO,
    lenderMonthlyFee
}) => {
    const periodicInterestRate = interestRate / (NUMBER.HUNDRED * periodsInAYear);
    const finalEmi = emiValue - ((lenderMonthlyFee * 12) / 52);
    const presentValue = finalEmi * (1 - Math.pow(1 + periodicInterestRate, -tenure)) / periodicInterestRate;
    const loanAmount = presentValue * -1;

    return Math.ceil(loanAmount);
};

// eslint-disable-next-line max-params
export const calculatePrincipalAU = (emiValue, interestRate, tenure, periodsInAYear = NUMBER.FIFTY_TWO) => {
    const periodicInterestRate = interestRate / (NUMBER.HUNDRED * periodsInAYear);
    const pr = emiValue * (1 - Math.pow(1 + periodicInterestRate, -tenure)) / periodicInterestRate;
    return Math.ceil(pr);
};

export const calcualateDownPayment = (vehiclePrice, loanAmount) => {
    return +vehiclePrice - +loanAmount;
};
export const getLoanAmountWithCharges = (totalCharges, vehiclePrice, downPayment) => {
    return Math.round((vehiclePrice - downPayment) + totalCharges);
};
